import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

import {AuthService} from 'src/app/services/auth.service';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { RequestHeaders } from 'src/app/models/request-headers.enum';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private auth: AuthService, private activatedRoute: ActivatedRoute,  private apiService: ApiService) {
  }

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    
      if ((request.url.includes('bo-api') || request.url.includes('bo-ptdesk') || request.url.includes('bo-auth') || request.url.includes('bo-admin') || request.url.includes('bo-work') || request.url.includes('bo-tfw')) && this.auth.isAuthenticated()) {

        var serverType = this.apiService.getServerTypeByUrl(request.url);

        // Without a resolved type the failover interceptor has no pool to
        // retry against, so leave the header off rather than send "null".
        const resilienceHeader = serverType ? { 'X-resilience-server': serverType } : {};

        if(this.activatedRoute.snapshot.queryParamMap.get('testid'))
          request = request.clone({ setHeaders: { ...resilienceHeader, 'X-TestId': this.activatedRoute.snapshot.queryParamMap.get('testid'), 'X-ClientId': localStorage.getItem('clientId'), Authorization:  this.auth.getTokenType() + ` ${this.auth.getAuthToken()}`} });
        else
          request = request.clone({ setHeaders: { ...resilienceHeader, Authorization:  this.auth.getTokenType() + ` ${this.auth.getAuthToken()}`, 'X-ClientId': localStorage.getItem('clientId'), } });

    }
    return next.handle(request);
  }
}
